/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1",
    spendId: "30",
    title: "Sản lượng dầu khí xuất bán",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1.1",
    spendId: "30a",
    title: "sản lượng dầu khí xuất bán quy đổi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1.2",
    spendId: "30b",
    title: "Hệ số quy đổi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "2",
    spendId: "31",
    unit: "%",
    title: "Tỷ lệ dầu để lại theo kế hoạch",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "3",
    unit: "USD",
    spendId: "32",
    title: "Sản lượng dầu lãi tạm tính",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4",
    spendId: "33",
    title: "Giá tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "5",
    unit: "USD/thùng",
    spendId: "34",
    title: "Giá dầu thô cơ sở",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "6",
    unit: "USD",
    spendId: "35",
    title: "Doanh thu",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "7",
    unit: "USD",
    spendId: "36",
    title: "Số tiền thuế tài nguyên tạm tính phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "8",
    unit: "USD",
    spendId: "37",
    title: "Số tiền thuế đặc biệt tạm tính phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    unit: "USD",
    index: "9",
    spendId: "38",
    title: "Số phụ thu tạm tính phải nộp [38]=[39] hoặc [40]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "9.1",
    unit: "USD",
    spendId: "39",
    title: "Trường hợp {1,2x[34]}<[33]<= {1,5x[34]}: [39]=50%x{[33]-1,2x[34]}x[32]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    unit: "USD",
    index: "9.2",
    spendId: "40",
    title: "Trường hợp [33] > {1,5x[34]}: [40]=[41] + [42]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "a.",
    unit: "USD",
    spendId: "41",
    title: "Phụ thu theo mức 50% [41] = 50%x{1,5x[34]-1,2x[34]}x[32]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "b.",
    unit: "USD",
    spendId: "42",
    title: "Phụ thu theo mức 60% [42] = 60%x{[33]-1,5x[34]}x[32]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "10",
    spendId: "43",
    unit: "USD",
    title: "Số thuế TNDN tạm tính phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "11",
    spendId: "44",
    unit: "VND/USD",
    title: "Tỷ giá quy đổi",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (index) => ["9", "9.1", "9,2", "a.", "b."].includes(index) || !index;

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    fontWeight: 800,
                  }}
                >
                  [{index + 26}]
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {!item.unit ? (
                    <select
                      style={selectStyle}
                      onChange={(e) =>
                        handleChange({ id: item.id, name: "value4", value: e.target.value })
                      }
                    >
                      <option value="1">USD</option>
                      <option value="1">VND</option>
                    </select>
                  ) : (
                    item.unit
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(item.index) ? (
                    ""
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
